import React from "react";
import { Quote } from "react-bootstrap-icons";

const testimonials = [
  {
    quote:
      "The UKG Pro WFM training was outstanding. The team explained everything in a way that was easy to understand and directly applicable to our day-to-day operations. Our workforce managers feel more confident and efficient than ever.",
    name: "Sarah Mitchell",
    title: "HR Director",
  },
  {
    quote:
      "Their ongoing support has been a game-changer for us. Anytime we've had questions or needed quick help, they've been there. I can't imagine navigating UKG Pro WFM without their expertise backing us up.",
    name: "Emily Johnson",
    title: "Operations Manager",
  },
  {
    quote:
      "Implementation support was seamless from start to finish. They anticipated challenges before we even noticed them and guided us through every step. It truly felt like a partnership, not just a service.",
    name: "James Carter",
    title: "IT Director",
  },
];

export default function Testimonials() {
  return (
    <section className="py-5" id="testimonials">
      <div className="container text-center">
        {/* Badge */}
        <span className="badge rounded-pill bg-light text-primary mb-3 px-3 py-2">
          Testimonials
        </span>

        {/* Heading */}
        <h2 className="fw-bold mb-3">What Our Clients Say</h2>
        <p className="text-muted mb-5">
          Don't just take our word for it — hear from the organizations we've
          helped transform
        </p>

        {/* Cards */}
        <div className="row g-4">
          {testimonials.map((item, i) => (
            <div key={i} className="col-lg-4 col-md-6">
              <div className="testimonial-card h-100 text-start">
                <div className="quote-icon mb-3">
                  <Quote size={22} />
                </div>

                <p className="testimonial-text mb-4">
                  “{item.quote}”
                </p>

                <hr />

                <h6 className="fw-bold mb-0">{item.name}</h6>
                <small className="text-muted">{item.title}</small>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
